import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { Button } from '@gn-audio/jss-components/components';
import { mapSharedPropertiesToFields } from '@gn-audio/jss-components/getters/utils';
import { SitecoreFieldTypes } from '@gn-audio/jss-components/types';

import { DualColumnPromoItem } from './dualColumnPromoTypes';

const PromoItem = ({ item }: { item: DualColumnPromoItem }) => {
  const {
    image,
    headline,
    description,
    firstButtonLink,
    firstButtonText,
    firstButtonVariant,
    secondButtonLink,
    secondButtonText,
    secondButtonVariant,
  } = mapSharedPropertiesToFields<DualColumnPromoItem>(item as SitecoreFieldTypes);

  return (
    <article className="flex flex-col items-start">
      <Image field={image} className="mb-6 rounded-3xl" />
      {!!headline.value && (
        <h3
          className="heading-3 mb-6"
          dangerouslySetInnerHTML={{ __html: sanitize(headline.value as string) }}
        />
      )}
      {!!description.value && (
        <p
          className="paragraph mb-6"
          dangerouslySetInnerHTML={{ __html: sanitize(description.value as string) }}
        />
      )}
      <section className="flex flex-col flex-wrap gap-6 md:flex-row">
        {!!firstButtonLink.value?.href && !!firstButtonText.value && (
          <Button
            asLink
            href={firstButtonLink.value.href}
            size="m"
            variant={firstButtonVariant.value || 'primary'}
          >
            {firstButtonText.value}
          </Button>
        )}
        {!!secondButtonLink.value?.href && !!secondButtonText.value && (
          <Button
            asLink
            href={secondButtonLink.value.href}
            size="m"
            variant={secondButtonVariant.value || 'secondary'}
          >
            {secondButtonText.value}
          </Button>
        )}
      </section>
    </article>
  );
};
export default PromoItem;
